<template>
    <!--<div class="under-construction">
    <img src="../assets/images/bg.jpg" alt="" />
  </div>-->
    <plug v-if="isPlug" />
    <template v-else>
        <template v-if="$route.path === '/nikahi'">
            <HeaderNikahi />
            <BannerNikahi />
        </template>
        <template v-else>
            <app-header v-if="$route.path !== '/sadaka'" :login="login" />
            <main-page-banner v-if="$route.path === '/'" />
        </template>
        <router-view />
        <app-footer v-if="$route.path !== '/nikahi' && $route.path !== '/sadaka'" :login="login" />
    </template>
</template>

<script>
import AppFooter from "./components/AppFooter.vue";
import AppHeader from "./components/AppHeader.vue";
import MainPageBanner from "@/components/MainPageBanner.vue";
import Plug from "./components/Plug.vue";
import HeaderNikahi from "@/components/nikahi/HeaderNikahi.vue";
import BannerNikahi from "@/components/nikahi/BannerNikahi.vue";
export default {
    components: { AppHeader, MainPageBanner, AppFooter, Plug, HeaderNikahi, BannerNikahi },
    name: "app",
    data() {
        return {
            isPlug: false,
            login: "Личный кабинет",
        };
    },
};
</script>
<style>
.wrapper-content {
    min-height: max-content !important;
}
.wrapper-content {
    width: 100%;
    min-height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow-x: hidden;
    margin: 0 auto;
    background-color: var(--white);
}
</style>
